module.exports = __webpack_public_path__ + "img/mystery_toss.2aaaff94.png";